import React from 'react';
import { Space, Popover } from 'antd';
import ToggleIcon from '@icons/common/toggle.svg';
import { ToggleButton } from '@src/components/common/Utils/Buttons';

const Content = ({ children }: { children: React.ReactNode }) => {
  return (
    <Space direction="vertical">
      <Space direction="horizontal" style={{ alignItems: 'flex-start' }}>
        {children}
      </Space>
    </Space>
  );
};

function ActionPopover({ children, zIndex }: { zIndex?: number; children: React.ReactNode }) {
  return (
    <Popover
      content={<Content>{children}</Content>}
      // getPopupContainer={node.getContainer}
      title=""
      trigger="click"
      placement="topRight"
      styles={{ body: { paddingLeft: 20 } }}
      zIndex={zIndex || 900}
    >
      <ToggleButton icon={<ToggleIcon />} />
    </Popover>
  );
}

export default ActionPopover;
